import React from 'react';
import cx from 'classnames';

import { barHeight, rowHeight } from '../constants';

interface PerformanceBarProps {
    hasPerformanceData: boolean;
    isSelected: boolean;
}

/**
 * Renders a colored bar with a ReportPeriodColumn that shows whether the period has performance
 * data. If a bar does not have data and is selected, a dotted border shows that there is the
 * missing data.
 *
 * Unlike a DetectionBar, a PerformanceBar can not have partial data; either we have a statement
 * that corresponds to this performance period or we don't.
 * @param props - {@link PerformanceBarProps}
 * @returns JSX
 */
export const PerformanceBar = ({
    hasPerformanceData,
    isSelected,
}: PerformanceBarProps): JSX.Element => (
    <div className="flex flex-col justify-center" style={{ height: rowHeight }}>
        <div
            className={cx({
                'bg-secondary-500': hasPerformanceData,
                'border-2 border-dotted border-secondary-500':
                    !hasPerformanceData && isSelected,
            })}
            style={{ height: barHeight }}
        />
    </div>
);
